import { passCodes } from '../passCodes';

export const step27door = {
    id: 27,
    title: 'Vrata',
    taskText: `
        <p>
            Odpovězte správně a posunte se dál. Odpovědi najdete někde v okolí.
        </p>
    `,
    cipher: {
        text: `
            <p>
                <b>2. otázka ze 4:</b>
            </p>
            <p>
                Co je pod klikou na vratech?
            </p>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[10],
    additionalInfo: 'Odpovědí je jedno nebo 2 slova',
    points: false,
    hints: [
        {
            text: 'Správná odpověď je klíčová dírka nebo zámek',
        },
    ],
};
